import React, { useEffect, useState } from "react";
import "../../../style/createordermodal.css";

export type OrderServiceType = "full" | "design" | "slot";

interface Props {
  open: boolean;
  onClose: () => void;
  onContinue: (type: OrderServiceType) => void;
}

const OPTIONS: { key: OrderServiceType; title: string; desc: string; icon: string }[] = [
  {
    key: "full",
    title: "Design and delivery",
    desc: "We design and deliver your crowns",
    icon: "bi-box-seam",
  },
  {
    key: "design",
    title: "Design only",
    desc: "We provide you with design files",
    icon: "bi-display",
  },
  {
    key: "slot",
    title: "Schedule for later",
    desc: "We block a slot for you and prompt you to upload scan at the time of appointment.",
    icon: "bi-calendar2",
  },
];

const CreateOrderTypeModal: React.FC<Props> = ({ open, onClose, onContinue }) => {
  const [selected, setSelected] = useState<OrderServiceType>("full");

  useEffect(() => {
    if (!open) return;
    setSelected("full");
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="cot-overlay" onClick={onClose}>
      <div
        className="cot-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cot-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cot-head">
          <div>
            <h5 id="cot-title">Create new order</h5>
            <p>Choose how you want to proceed with the selected teeth.</p>
          </div>
          <button type="button" className="cot-close" aria-label="Close" onClick={onClose}>
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        <div className="cot-body" role="radiogroup">
          {OPTIONS.map((o) => (
            <button
              key={o.key}
              type="button"
              role="radio"
              aria-checked={selected === o.key}
              className={`cot-option ${selected === o.key ? "selected" : ""}`}
              onClick={() => setSelected(o.key)}
            >
              <span className="cot-icon">
                <i className={`bi ${o.icon}`}></i>
              </span>
              <span className="cot-text">
                <strong>{o.title}</strong>
                <small>{o.desc}</small>
              </span>
            </button>
          ))}
        </div>

        <div className="cot-foot">
          <button type="button" className="cot-btn cancel" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="cot-btn primary" onClick={() => onContinue(selected)}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateOrderTypeModal;
